module.exports = __webpack_public_path__ + "media/recipes/83-12227f65.png";